import { useEffect, useRef, useState } from 'react';
import $ from 'jquery';

const links = ['home', 'about', 'skills', 'formation', 'projects', 'contact'];

export default function Navbar() {
  const [scrolled, setScrolled]   = useState(false);
  const [menuOpen, setMenuOpen]   = useState(false);
  const [active, setActive]       = useState('home');
  const navRef = useRef(null);

  useEffect(() => {
    const $nav = $(navRef.current);

    // Fade-in links — desktop only
    if (window.innerWidth > 768) {
      $nav.find('.nav-link').each(function (i) {
        $(this).delay(i * 120).animate({ opacity: 1 }, 400);
      });
    } else {
      $nav.find('.nav-link').css('opacity', 1);
    }

    // Scroll: glass navbar + active section
    const onScroll = () => {
      setScrolled(window.scrollY > 50);

      // Determine active section
      let current = 'home';
      links.forEach(id => {
        const el = document.getElementById(id);
        if (el && window.scrollY >= el.offsetTop - 120) current = id;
      });
      setActive(current);
    };
    window.addEventListener('scroll', onScroll);

    // Smooth scroll
    $nav.find('a[href^="#"]').on('click', function (e) {
      e.preventDefault();
      const target = $(this.getAttribute('href'));
      if (target.length) {
        $('html, body').animate({ scrollTop: target.offset().top - 70 }, 700, 'swing');
      }
      setMenuOpen(false);
    });

    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <nav ref={navRef} className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="nav-brand">
        <span className="brand-bracket">&lt;</span>
        Zidane
        <span className="brand-bracket">/&gt;</span>
      </div>

      <button
        className={`hamburger ${menuOpen ? 'open' : ''}`}
        onClick={() => setMenuOpen(!menuOpen)}
        aria-label="Toggle menu"
      >
        <span /><span /><span />
      </button>

      <ul className={`nav-links ${menuOpen ? 'open' : ''}`}>
        {links.map((id, i) => (
          <li key={i}>
            <a
              href={`#${id}`}
              className={`nav-link ${active === id ? 'nav-active' : ''}`}
              style={{ opacity: 0 }}
            >
              {id.charAt(0).toUpperCase() + id.slice(1)}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}
